export default "__VITE_ASSET__Cc1WXPJ1__"